import { Injectable } from '@angular/core';
import { DataService } from '../../shared-service/data.service';
import { BaseService } from '../../shared-service/base.service';

@Injectable()
export class ViewMoreLikeThisService {

	constructor(private dataService: DataService, private bs: BaseService) {
		this.bs.log('info', "Loaded view more like this Service");
	}

	getSuggestedLearningsFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'Learning/GetMoreLikeThisLearnings';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	};
}
